import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import { Button, Popover, TextControl } from '@wordpress/components';
import { kanewsIcons } from '../../utils/icons';
// import './style.scss';

const IconPicker = ({ 
    value = '', 
    onChange,
    label = __('İkon Seç', 'kanews'),
    placeholder = __('İkon ara...', 'kanews')
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredIcons, setFilteredIcons] = useState(kanewsIcons);

    // İkon arama fonksiyonu
    const handleSearch = (term) => {
        setSearchTerm(term);
        if (term) {
            const filtered = kanewsIcons.filter(icon => 
                icon.label.toLowerCase().includes(term.toLowerCase()) || 
                icon.value.toLowerCase().includes(term.toLowerCase())
            );
            setFilteredIcons(filtered);
        } else {
            setFilteredIcons(kanewsIcons);
        }
    };

    // İkon seçme fonksiyonu
    const handleSelect = (iconValue) => {
        onChange(iconValue);
        setIsOpen(false);
        setSearchTerm('');
        setFilteredIcons(kanewsIcons);
    };

    // Seçili ikonun etiketini bul
    const selectedIcon = kanewsIcons.find(icon => icon.value === value);

    return (
        <div className="kanews-icon-picker">
            <div className="kanews-icon-picker__button">
                <Button
                    className="kanews-icon-picker__button-content"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                >
                    {value ? (
                        <>
                            <i className={value}></i>
                            <span>{selectedIcon ? selectedIcon.label : value}</span>
                        </>
                    ) : (
                        <span>{label}</span>
                    )}
                </Button>
            </div>
            {isOpen && (
                <Popover
                    className="kanews-icon-picker__popover"
                    position="bottom left"
                    onClose={() => setIsOpen(false)}
                >
                    <div className="kanews-icon-picker__search">
                        <TextControl
                            value={searchTerm}
                            onChange={handleSearch}
                            placeholder={placeholder}
                        />
                    </div>
                    <div className="kanews-icon-picker__list">
                        {filteredIcons.map((icon) => (
                            <Button
                                key={icon.value}
                                className={`kanews-icon-picker__item ${value === icon.value ? 'is-selected' : ''}`}
                                onClick={() => handleSelect(icon.value)}
                            >
                                <i className={icon.value}></i>
                                <span>{icon.label}</span>
                            </Button>
                        ))}
                    </div>
                </Popover>
            )}
        </div>
    );
};

export default IconPicker; 